import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

export function getColumns(columnsConditions = {}) {
  const columns = prepareColumns();

  return columns.filter((item) => {
    // eslint-disable-next-line no-prototype-builtins
    if (columnsConditions.hasOwnProperty(item.name)) {
      return columnsConditions[item.name];
    }
    return true;
  });
}

function prepareColumns() {
  return [
    {
      name: 'status',
      title: '',
      width: 50,
    },
    {
      name: 'sector',
      title: 'Sector',
      sortable: true,
      className: alignStyles.alignLeft,
      width: 70,
    },
    {
      name: 'name',
      title: 'Bond',
      sortable: true,
      className: alignStyles.alignLeft,
      width: 140,
    },
    {
      name: 'originalFace',
      title: 'Orig Face',
      sortable: true,
      className: alignStyles.alignRight,
      width: 110,
      tooltipContent: 'Original Face',
    },
    {
      name: 'currentFace',
      title: 'Curr Face',
      sortable: true,
      className: alignStyles.alignRight,
      width: 110,
      tooltipContent: 'Current Face',
    },
    {
      name: 'wal',
      title: 'Wal',
      sortable: true,
      className: alignStyles.alignRight,
      tooltipContent: 'Weighted Average Life',
    },
    {
      name: 'ratingMoodys',
      title: 'MO',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'Moody\'s Rating',
    },
    {
      name: 'ratingSAndP',
      title: 'SP',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'S&P Rating',
    },
    {
      name: 'ratingFitch',
      title: 'FI',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'Fitch Rating',
    },
    {
      name: 'ratingDbrs',
      title: 'DR',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'DBRS Morningstar Rating',
    },
    {
      name: 'ratingKroll',
      title: 'KR',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'Kroll Rating',
    },
    {
      name: 'ratingOtherOrUnspecified',
      title: 'OT',
      sortable: true,
      className: alignStyles.alignCenter,
      tooltipContent: 'Other / Unspecified Rating',
    },
    {
      name: 'spread',
      title: 'Spread',
      sortable: true,
      className: alignStyles.alignRight,
      width: 70,
    },
    {
      name: 'speed',
      title: 'Speed',
      sortable: true,
      className: alignStyles.alignRight,
      width: 70,
    },
    {
      name: 'ce',
      title: 'C/E',
      sortable: true,
      className: alignStyles.alignRight,
    },
    {
      name: 'priceTalk',
      title: 'Price Talk',
      sortable: true,
      className: alignStyles.alignRight,
    },
    {
      name: 'dealer',
      title: 'Dealer',
      sortable: true,
      className: alignStyles.alignRight,
      tooltipContent: 'Broker-Dealer',
    },
    {
      name: 'listId',
      title: 'List ID',
      sortable: true,
      className: alignStyles.alignRight,
      width: 100,
      minWidth: 100,
    },
    {
      name: 'dueBy',
      title: 'Due By (ET)',
      sortable: true,
      className: alignStyles.alignRight,
      width: 150,
      minWidth: 150,
    },
  ];
}
